import $ from "jquery";
const InputFormat = {
    created() { },
    beforeMount(el, binding, vnode) {
        const jqueryEl = $(el);
        switch (binding.value) {
            case "moeda":
                jqueryEl.priceFormat({
                    prefix: "R$ ",
                    centsSeparator: ",",
                    thousandsSeparator: ".",
                });
                break;
            case "moeda-inteiro":
                jqueryEl.priceFormat({
                    prefix: "R$ ",
                    thousandsSeparator: ".",
                    centsLimit: 0,
                });
                break;
            case "number":
            case "decimal":
            case "numero":
                jqueryEl.priceFormat({
                    prefix: "",
                    centsSeparator: ",",
                    thousandsSeparator: ".",
                });
                break;
            case "integer":
            case "inteiro":
                jqueryEl.priceFormat({
                    prefix: "",
                    centsSeparator: "",
                    thousandsSeparator: "",
                    centsLimit: 0,
                });
                break;
            case "percentual":
                jqueryEl.priceFormat({
                    prefix: "",
                    centsSeparator: ",",
                    thousandsSeparator: ".",
                    clearPrefix: true,
                });
                break;
            default:
                console.error("InputFormat não programado para o tipo.", binding.value);
                break;
        }
        /**
         * Forçar a atualização do model no vue
         */
        jqueryEl.on("priceformat.change", function (event) {
            el.value = event.target.value;
            el.dispatchEvent(new Event("input", { bubbles: true }));
            el.dispatchEvent(new Event("change", { bubbles: true })); //safari compat
        });
    },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeUnmount(el) {
        const jqueryEl = $(el);
        jqueryEl.unpriceFormat();
    },
    unmounted() { },
};
export default InputFormat;
